import React from 'react';
import PropTypes from 'prop-types';

import ManageRefund from '../../../components/siteadmin/ManageRefund/MangeRefund';

import getAllRefundReservation from './getAllRefundReservation.graphql';
import { withQuery } from '../../../hoc/withGraphql';

class RefundManagement extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        data: PropTypes.shape({
            loading: PropTypes.bool,
            getAllRefundReservation: PropTypes.array,
        })
    }

    render() {
        const { title, getAllRefunds } = this.props;
        return <ManageRefund title={title} getAllRefunds={getAllRefunds} />

    }
}

export default
    withQuery(getAllRefundReservation, {
        name: 'getAllRefunds',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only',
            ssr: false
        }
    })
        (RefundManagement);